/**
 * Created by prog2 on 25/10/2018.
 */

export default {
    message: {
        title: 'CATTEDRALE DI VALENCIA',
        preferVisitRead: 'Prefereixo llegir',
        preferVisitListten: 'Prefereixo escoltar ',
        downloadAudio: '(descarregar audios)',
        download:'Downloading',
        errorDownload: 'Hi hagut un error en la descàrrega.',
        cancelDownload: 'Has cancel·lat la descàrrega.',
        initDownload: 'Attendere la fine del download degli audio',
        endDownload: 'Download terminato. Buona visita!',
        retry: 'Reintentar',
        noConnection: 'No tens conexió a internet',
        titleMap: '',
        map: 'Plano1.png',
        menuItems: [
            {
                idImages: 1,
                title: 'Benvenuto',
                author: 'Si prega di utilizzare le cuffie',
                description: '',
                // audio: require('./../../assets/audio/ESP/1.mp3')
                audio: '1.mp3'
            },
            {
                idImages: 2,
                title: 'Cappella de S. Sebastiano',
                author: 'Inizio della navata',
                description: '',
                audio: '2.mp3'

            },
            {
                idImages: 3,
                title: 'Cappella de S. Pietro Apostolo ',
                author: 'Navata laterale destra',
                description: '',
                audio: '3.mp3'

            },
            {
                idImages: 4,
                title: 'Cappella de S. Francesco Borgia',
                author: 'Navata laterale destra',
                description: '',
                audio: '4.mp3'

            },
            {
                idImages: 5,
                title: 'Finestra dall\'arco obliquo',
                author: '',
                description: '.',
                audio: '5.mp3'

            },
            {
                idImages: 6,
                title: 'Altare Maggiore',
                author: 'Cappella Maggiore',
                description: '',
                audio: '6.mp3'

            },
            {
                idImages: 7,
                title: 'Angeli musicanti',
                author: 'Cappella Maggiore',
                description: '',
                audio: '7.mp3'

            },
            {
                idImages: 8,
                title: 'Torre nolare',
                author: 'Crociera',
                description: '',
                audio: '8.mp3'

            },
            {
                idImages: 9,
                title: 'Porta dell\'Elemosina',
                author: 'Braccio destro della crociera',
                description: '',
                audio: '9.mp3'

            },
            {
                idImages: 10,
                title: 'Deambulatorio + Organo',
                author: 'Deambulatorio',
                description: '',
                audio: '10.mp3'

            },
            {
                idImages: 11,
                title: 'Resurrezione',
                author: 'Cappelle del deambulatorio ',
                description: '',
                audio: '11.mp3'

            },
            {
                idImages: 12,
                title: 'Cristo della Buona Morte',
                author: 'Cappelle del deambulatorio ',
                description: '',
                audio: '12.mp3'

            },
            {
                idImages: 13,
                title: 'Madonna della Seggiola',
                author: 'Cappelle del deambulatorio ',
                description: '',
                audio: '13.mp3'

            },
            {
                idImages: 14,
                title: 'SS. Margherita e Dionigi',
                author: 'Cappelle del deambulatorio ',
                description: '',
                audio: '14.mp3'

            },
            {
                idImages: 15,
                title: 'Porta degli Apostoli',
                author: 'Braccio sinistro della crociera',
                description: '',
                audio: '15.mp3'

            },
            {
                idImages: 16,
                title: 'Prosecuzione della visita',
                author: 'Navata laterale sinistra',
                description: '',
                audio: '16.mp3'

            },
            {
                idImages: 17,
                title: 'Ostensorio',
                author: 'Museo: Piano terra',
                description: '',
                audio: '17.mp3'

            },
            {
                idImages: 18,
                title: 'Cattivo ladrone + Adorazione',
                author: 'Museo: Piano terra',
                description: '',
                audio: '18.mp3'

            },
            {
                idImages: 19,
                title: 'Plastici',
                author: 'Museo: Secondo piano',
                description: '',
                audio: '19.mp3'

            },
            {
                idImages: 20,
                title: 'Apostoli ',
                author: 'Museo: Secondo piano',
                description: '',
                audio: '20.mp3'

            },
            {
                idImages: 21,
                title: 'Incredulità + Dormizione',
                author: 'Museo: Secondo piano',
                description: '',
                audio: '21.mp3'

            },
            {
                idImages: 22,
                title: 'Reliquiario',
                author: 'Museo: Secondo piano',
                description: '',
                audio: '22.mp3'

            },
            {
                idImages: 23,
                title: 'Cristo deriso',
                author: 'Museo: Secondo piano',
                description: '',
                audio: '23.mp3'

            },
            {
                idImages: 24,
                title: 'Corridoio + Arte barocca',
                author: 'Museo: Secondo piano',
                description: '',
                audio: '24.mp3'

            },
            {
                idImages: 25,
                title: 'Scavi archeologici',
                author: 'Museo: Soterraneo',
                description: '',
                audio: '25.mp3'

            },
            {
                idImages: 26,
                title: 'Libri del Coro + Ultima Cena',
                author: 'Museo: Piano terra',
                description: '',
                audio: '26.mp3'

            },
            {
                idImages: 27,
                title: 'Il Santo Calice',
                author: 'Cappella del Santo Calice',
                description: '',
                audio: '27.mp3'

            },
            {
                idImages: 28,
                title: 'Cappella del Santo Calice',
                author: 'Cappella del Santo Calice',
                description: '',
                audio: '28.mp3'

            },
            {
                idImages: 29,
                title: 'Il Micalet ',
                author: 'Inizio della navata',
                description: '',
                audio: '29.mp3'

            },
            {
                idImages: 30,
                title: 'Credits',
                isCredits:true,
                author: '',
                description: 'Trama Media para la Cattedrale di Valencia.<br><br>© Cattedrale di Valencia.<br><br>Tutti i diritti reservati.<br><br>',
                audio: '',
                idCreditImage: 30,
            },


        ]

    }
};



// WEBPACK FOOTER //
// ./src/data/i18n/italiano.js